<template>
  <div class="ima-user-modal">

    <div class="columns">
      <div class="column">
        <b-field label="Vorname*">
          <b-input v-model="firstName" :required="true" ref="autofocus"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nachname*">
          <b-input v-model="lastName" :required="true"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Benutzername">
          <b-input v-model="userName"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Passwort*">
          <b-input v-model="password" :required="!isExistingUser" :disabled="isExistingUser && !canChangeUserPassword"></b-input>
        </b-field>
      </div>

    </div>

    <div class="columns">
      <div class="column">

        <b-field label="E-Mail*">
          <b-input v-model="email" :required="true"></b-input>
        </b-field>

        <br />

        <b-field label="Benutzer muss Passwort ändern">
         <b-switch v-model="hasToChangePassword">
                {{ hasToChangePassword ? 'Ja' : 'Nein' }}
            </b-switch>
        </b-field>

      </div>
      <div class="column">
        <b-field label="Rolle*">
          <b-select v-model="userRoles" placeholder="Auswählen" required icon="perm_identity" expanded multiple>
            <option v-for="role in options.roles" :value="role.value" :key="role.value">
              {{ role.label }}
            </option>
          </b-select>
        </b-field>
        <small>Mehrfachauswahl durch
          <code>STRG</code>-Taste möglich.</small>
      </div>
    </div>

    <div :style="{'text-align': 'right'}">
      <button type="button" class="button is-success" :disabled="!isValidForm || users.isSaving" @click="onConfirm">OK</button>
      <button type="button" class="button is-danger" :disabled="users.isSaving" @click="onCancel">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { saveUser, unselectUser } from '@/store/modules/users'
import { closeModals } from '@/store/modules/modals'
import modals from '@/mixins/modals'
import {
  canCreateSpecificRole,
  canChangeUserPassword
} from '@/services/permissions'

export default {
  name: 'ima-user-modal',
  data () {
    return {
      id: null,
      firstName: null,
      lastName: null,
      userName: null,
      password: null,
      hasToChangePassword: false,
      userRoles: [],
      email: null
    }
  },
  computed: {
    ...mapState(['user', 'users', 'roles']),
    isValidForm () {
      return (
        this.firstName &&
        this.lastName &&
        this.userRoles &&
        this.email &&
        (this.isExistingUser || this.password)
      )
    },
    options () {
      return {
        roles: this.roles.data
          .filter(({ id }) => canCreateSpecificRole(id))
          .map(({ id, name }) => ({ value: id, label: name }))
      }
    },
    isExistingUser () {
      return this.id
    },
    canChangeUserPassword () {
      const existingUserIsIMAUser = this.users.selectedUser.roles.includes(1)
      const currentUserIsIMAUser = this.user.data.role === 1
      return (
        canChangeUserPassword() &&
        (!existingUserIsIMAUser ||
          (existingUserIsIMAUser && currentUserIsIMAUser))
      )
    }
  },
  mixins: [modals],
  methods: {
    ...mapActions([saveUser]),
    ...mapMutations([closeModals, unselectUser]),
    onCancel () {
      this.unselectUser()
      this.closeModals()
    },
    onConfirm () {
      const {
        id,
        firstName,
        lastName,
        userName,
        password,
        userRoles,
        hasToChangePassword,
        email
      } = this
      const user = {
        id,
        firstName,
        lastName,
        userName,
        hasToChangePassword,
        roles: userRoles,
        email
      }

      if (password && password.length) {
        user.password = password
      }
      this.saveUser(user).then(user => {
        this.closeModals()
        this.unselectUser()
      })
    }
  },
  created () {
    if (this.users.selectedUser) {
      const {
        id,
        firstName,
        lastName,
        userName,
        hasToChangePassword,
        roles,
        email
      } = this.users.selectedUser
      this.id = id
      this.firstName = firstName
      this.lastName = lastName
      this.userName = userName
      this.hasToChangePassword = hasToChangePassword
      this.email = email
      this.userRoles = roles
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/UserModal.vue